import { Button as ButtonLib } from 'antd';
import styled from 'styled-components';

export const Button = styled(ButtonLib)`
  border-radius: 10px;
  border: none;
  line-height: inherit;
  padding: 16px 25px;
  height: inherit;
  font-size: 13px;

  color: ${props => {
    switch (props.type) {
      default:
        return '#4BFFA5';
    }
  }};

  background-color: ${props => {
    switch (props.type) {
      default:
        return '#292929';
    }
  }};

  &:hover, &:active, &:focus {
    color: #fff;

    background-color: ${props => {
      switch (props.type) {
        default:
          return '#383838';
      }
    }};
  }

  i {
    padding: 8px 13px 8px 13px;
    border-radius: 7px;
    margin-left: 28px !important;
    height: inherit;
    line-height: inherit;

    background-color: ${props => {
      switch (props.type) {
        default:
          return '#1C1C1C';
      }
    }};
  }
`;
